import { combineReducers } from 'redux'
import createAvailabilityReducer, { createAvailabilityActions } from '@store/slices/calendar/createAvailability'
import editAvailabilityReducer, { editAvailabilityActions } from '@store/slices/calendar/editAvailability'
import oneAvailabilityReducer, { oneAvailabilityActions } from '@store/slices/calendar/oneAvailability'
import syncReducer, { syncActions } from '@store/slices/calendar/sync'
import syncAuthenticateURLReducer, { syncAuthenticateURLActions } from '@store/slices/calendar/syncAuthenticateURL'
import getConnectedCalendarReducer, { getConnectedCalendarActions } from '@store/slices/calendar/getConnectedCalendar'
import removeSyncReducer, { removeSyncActions } from '@store/slices/calendar/removeSync'
import listReducer, { listActions } from '@store/slices/calendar/list'
import deleteReducer, { deleteCalendarActions } from '@store/slices/calendar/delete'
import syncAuthenticateUrlByTokenReducer, {
    syncAuthenticateUrlByTokenActions
} from '@store/slices/calendar/syncAuthenticateUrlByToken'
import syncByTokenReducers, { syncByTokenActions } from '@store/slices/calendar/syncByToken'
import createAvailabilityByTokenReducer, {
    createAvailabilityByTokenActions
} from '@app-store/slices/calendar/createAvailabilityByToken'
import listByTokenReducer, { listByTokenActions } from '@store/slices/calendar/lisByToken'
import editAvailabilityByTokenReducer, {
    editAvailabilityByTokenActions
} from '@store/slices/calendar/editAvailabilityByToken'
import getConnectedCalendarByTokenReducer, {
    getConnectedCalendarByTokenActions
} from '@store/slices/calendar/getConnectedCalendarByToken'
import removeSyncByTokenReducer, { removeSyncByTokenActions } from '@store/slices/calendar/removeSyncByToken'

export const calendarReducers = combineReducers({
    createAvailability: createAvailabilityReducer,
    editAvailability: editAvailabilityReducer,
    oneAvailability: oneAvailabilityReducer,
    sync: syncReducer,
    syncAuthenticateURL: syncAuthenticateURLReducer,
    getConnectedCalendar: getConnectedCalendarReducer,
    removeSync: removeSyncReducer,
    list: listReducer,
    delete: deleteReducer,
    syncAuthenticateUrlByToken: syncAuthenticateUrlByTokenReducer,
    syncByToken: syncByTokenReducers,
    createAvailabilityByToken: createAvailabilityByTokenReducer,
    listByToken: listByTokenReducer,
    editAvailabilityByToken: editAvailabilityByTokenReducer,
    getConnectedCalendarByToken: getConnectedCalendarByTokenReducer,
    removeSyncByToken: removeSyncByTokenReducer
})

export const calendarActions = {
    createAvailability: createAvailabilityActions,
    editAvailability: editAvailabilityActions,
    oneAvailability: oneAvailabilityActions,
    sync: syncActions,
    syncAuthenticateURL: syncAuthenticateURLActions,
    getConnectedCalendar: getConnectedCalendarActions,
    removeSync: removeSyncActions,
    list: listActions,
    delete: deleteCalendarActions,
    syncAuthenticateUrlByToken: syncAuthenticateUrlByTokenActions,
    syncByToken: syncByTokenActions,
    createAvailabilityByToken: createAvailabilityByTokenActions,
    listByToken: listByTokenActions,
    editAvailabilityByToken: editAvailabilityByTokenActions,
    getConnectedCalendarByToken: getConnectedCalendarByTokenActions,
    removeSyncByToken: removeSyncByTokenActions
}
